const fonts = [
  { label: 'FiraSans_Black', value: 'FiraSans_Black' },
  { label: 'FiraSans_Bold', value: 'FiraSans_Bold' },
  { label: 'FiraSans_Light', value: 'FiraSans_Light' },
  { label: 'FiraSans_Medium', value: 'FiraSans_Medium' },
  { label: 'FiraSans_Regular', value: 'FiraSans_Regular' },
  { label: 'FSMe_Regular', value: 'FSMe_Regular' },
  { label: 'Inter_100Thin', value: 'Inter_100Thin' },
  { label: 'Inter_200ExtraLight', value: 'Inter_200ExtraLight' },
  { label: 'Inter_300Light', value: 'Inter_300Light' },
  { label: 'Inter_400Regular', value: 'Inter_400Regular' },
  { label: 'Inter_500Medium', value: 'Inter_500Medium' },
  { label: 'Inter_600SemiBold', value: 'Inter_600SemiBold' },
  { label: 'Inter_700Bold', value: 'Inter_700Bold' },
  { label: 'Inter_800ExtraBold', value: 'Inter_800ExtraBold' },
  { label: 'Inter_900Black', value: 'Inter_900Black' },
  { label: 'Lato_100Thin', value: 'Lato_100Thin' },
  { label: 'Lato_100Thin_Italic', value: 'Lato_100Thin_Italic' },
  { label: 'Lato_300Light', value: 'Lato_300Light' },
  { label: 'Lato_300Light_Italic', value: 'Lato_300Light_Italic' },
  { label: 'Lato_400Regular', value: 'Lato_400Regular' },
  { label: 'Lato_400Regular_Italic', value: 'Lato_400Regular_Italic' },
  { label: 'Lato_700Bold', value: 'Lato_700Bold' },
  { label: 'Lato_700Bold_Italic', value: 'Lato_700Bold_Italic' },
  { label: 'Lato_900Black', value: 'Lato_900Black' },
  { label: 'Lato_900Black_Italic', value: 'Lato_900Black_Italic' },
  { label: 'Montserrat_100Thin', value: 'Montserrat_100Thin' },
  { label: 'Montserrat_200ExtraLight', value: 'Montserrat_200ExtraLight' },
  { label: 'Montserrat_300Light', value: 'Montserrat_300Light' },
  { label: 'Montserrat_400Regular', value: 'Montserrat_400Regular' },
  { label: 'Montserrat_500Medium', value: 'Montserrat_500Medium' },
  { label: 'Montserrat_600SemiBold', value: 'Montserrat_600SemiBold' },
  { label: 'Montserrat_700Bold', value: 'Montserrat_700Bold' },
  { label: 'Montserrat_800ExtraBold', value: 'Montserrat_800ExtraBold' },
  { label: 'Montserrat_900Black', value: 'Montserrat_900Black' },
  { label: 'Montserrat_100Thin_Italic', value: 'Montserrat_100Thin_Italic' },
  {
    label: 'Montserrat_200ExtraLight_Italic',
    value: 'Montserrat_200ExtraLight_Italic'
  },
  { label: 'Montserrat_300Light_Italic', value: 'Montserrat_300Light_Italic' },
  {
    label: 'Montserrat_400Regular_Italic',
    value: 'Montserrat_400Regular_Italic'
  },
  {
    label: 'Montserrat_500Medium_Italic',
    value: 'Montserrat_500Medium_Italic'
  },
  {
    label: 'Montserrat_600SemiBold_Italic',
    value: 'Montserrat_600SemiBold_Italic'
  },
  { label: 'Montserrat_700Bold_Italic', value: 'Montserrat_700Bold_Italic' },
  {
    label: 'Montserrat_800ExtraBold_Italic',
    value: 'Montserrat_800ExtraBold_Italic'
  },
  { label: 'Montserrat_900Black_Italic', value: 'Montserrat_900Black_Italic' },
  { label: 'OpenSans_300Light', value: 'OpenSans_300Light' },
  { label: 'OpenSans_400Regular', value: 'OpenSans_400Regular' },
  { label: 'OpenSans_500Medium', value: 'OpenSans_500Medium' },
  { label: 'OpenSans_600SemiBold', value: 'OpenSans_600SemiBold' },
  { label: 'OpenSans_700Bold', value: 'OpenSans_700Bold' },
  { label: 'OpenSans_800ExtraBold', value: 'OpenSans_800ExtraBold' },
  { label: 'OpenSans_300Light_Italic', value: 'OpenSans_300Light_Italic' },
  { label: 'OpenSans_400Regular_Italic', value: 'OpenSans_400Regular_Italic' },
  { label: 'OpenSans_500Medium_Italic', value: 'OpenSans_500Medium_Italic' },
  {
    label: 'OpenSans_600SemiBold_Italic',
    value: 'OpenSans_600SemiBold_Italic'
  },
  { label: 'OpenSans_700Bold_Italic', value: 'OpenSans_700Bold_Italic' },
  {
    label: 'OpenSans_800ExtraBold_Italic',
    value: 'OpenSans_800ExtraBold_Italic'
  },
  { label: 'Roboto_100Thin', value: 'Roboto_100Thin' },
  { label: 'Roboto_100Thin_Italic', value: 'Roboto_100Thin_Italic' },
  { label: 'Roboto_300Light', value: 'Roboto_300Light' },
  { label: 'Roboto_300Light_Italic', value: 'Roboto_300Light_Italic' },
  { label: 'Roboto_400Regular', value: 'Roboto_400Regular' },
  { label: 'Roboto_400Regular_Italic', value: 'Roboto_400Regular_Italic' },
  { label: 'Roboto_500Medium', value: 'Roboto_500Medium' },
  { label: 'Roboto_500Medium_Italic', value: 'Roboto_500Medium_Italic' },
  { label: 'Roboto_700Bold', value: 'Roboto_700Bold' },
  { label: 'Roboto_700Bold_Italic', value: 'Roboto_700Bold_Italic' },
  { label: 'Roboto_900Black', value: 'Roboto_900Black' },
  { label: 'Roboto_900Black_Italic', value: 'Roboto_900Black_Italic' },
  { label: 'DMSans_400Regular', value: 'DMSans_400Regular' },
  { label: 'DMSans_400Regular_Italic', value: 'DMSans_400Regular_Italic' },
  { label: 'DMSans_500Medium', value: 'DMSans_500Medium' },
  { label: 'DMSans_500Medium_Italic', value: 'DMSans_500Medium_Italic' },
  { label: 'DMSans_700Bold', value: 'DMSans_700Bold' },
  { label: 'DMSans_700Bold_Italic', value: 'DMSans_700Bold_Italic' },
  { label: 'Poppins_100Thin', value: 'Poppins_100Thin' },
  { label: 'Poppins_100Thin_Italic', value: 'Poppins_100Thin_Italic' },
  { label: 'Poppins_200ExtraLight', value: 'Poppins_200ExtraLight' },
  {
    label: 'Poppins_200ExtraLight_Italic',
    value: 'Poppins_200ExtraLight_Italic'
  },
  { label: 'Poppins_300Light', value: 'Poppins_300Light' },
  { label: 'Poppins_300Light_Italic', value: 'Poppins_300Light_Italic' },
  { label: 'Poppins_400Regular', value: 'Poppins_400Regular' },
  { label: 'Poppins_400Regular_Italic', value: 'Poppins_400Regular_Italic' },
  { label: 'Poppins_500Medium', value: 'Poppins_500Medium' },
  { label: 'Poppins_500Medium_Italic', value: 'Poppins_500Medium_Italic' },
  { label: 'Poppins_600SemiBold', value: 'Poppins_600SemiBold' },
  { label: 'Poppins_600SemiBold_Italic', value: 'Poppins_600SemiBold_Italic' },
  { label: 'Poppins_700Bold', value: 'Poppins_700Bold' },
  { label: 'Poppins_700Bold_Italic', value: 'Poppins_700Bold_Italic' },
  { label: 'Poppins_800ExtraBold', value: 'Poppins_800ExtraBold' },
  {
    label: 'Poppins_800ExtraBold_Italic',
    value: 'Poppins_800ExtraBold_Italic'
  },
  { label: 'Poppins_900Black', value: 'Poppins_900Black' },
  { label: 'Poppins_900Black_Italic', value: 'Poppins_900Black_Italic' }
];

export default fonts;
